import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from '../services/user-data.service';
import { inject } from '@angular/core';

export const adminGuard: CanActivateFn = async (route, state) => {
  const userData = inject(UserDataService);
  const router = inject(Router);

  if (!userData.getUser()) {
    // Load user data
    try {
      await userData.loadUserData();
    } catch (error) {
      router.navigate(['/auth/signup']);
      return false;
    }
  }

  if (!userData.getUser() || !userData.getUser()?.is_active || !userData.getUser()?.is_superuser) {
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
